export default "__VITE_ASSET__Bddorsiy__"